import { CCard, CCardBody } from '@coreui/react';
import React from 'react';

interface AuthRequiredProps {
  title?: string;
  message?: string;
}

export const AuthRequired: React.FC<AuthRequiredProps> = ({
  title = 'Authentication Required',
  message = 'Please log in to access this application.',
}) => {
  return (
    <div className="d-flex justify-content-center align-items-center min-vh-100">
      <CCard className="auth-required-card">
        <CCardBody className="text-center">
          <h4>{title}</h4>
          <p className="text-muted mb-0">{message}</p>
        </CCardBody>
      </CCard>
    </div>
  );
};
